import types from 'customer/types/Organisation.types'
import send from 'customer/lib/action'

export const getOrganisation = () =>
  send({
    method: 'get',
    path: `/org`,
    baseType: types.GET_ORGANISATION
  })
